import React, {
  useContext,
} from 'react';
import classNames from 'classnames';

import {
  Fieldset,
  Toggle,
  DateField,
  ToggleGroup,
} from '@ktag/styleguide/dist/react';

import {
  AddressInfo,
  FormConfigStore,
  AppFormField,
  FormUtils,
  Validators,
} from 'ewp-common';

  interface Props {
    id?: string;
    className?: string;
    additionalClassNames?: string;
  }

const OtherPersonInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const configs = formConfigState?.data?.labelsMap;

  const otherPersonInfoKey = 'otherPersonInfo';

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <div className="mt-4">
        <h2>{configs.otherPersonHeading.labelDisplayName}</h2>
        <Fieldset>
          <ToggleGroup
            name={FormUtils.getFieldName(configs.OfieldAnrede, otherPersonInfoKey)}
            label={configs.OfieldAnrede.labelDisplayName}
            required={configs.OfieldAnrede.mandatory === 'true'}
            infoText={configs.OfieldAnrede.labelDescription}
            horizontal
          >
            <Toggle type="radio" value="Herr" label="Herr" />
            <Toggle type="radio" value="Frau" label="Frau" />
          </ToggleGroup>
          <AppFormField formDataKey={otherPersonInfoKey} config={configs.OfieldName} autocomplete="family-name" />
          <AppFormField formDataKey={otherPersonInfoKey} config={configs.OfieldFirstname} autocomplete="given-name" />
          <DateField
            label={configs.OfieldDob.labelDisplayName}
            name={FormUtils.getFieldName(configs.OfieldDob, otherPersonInfoKey)}
            placeholder={configs.OfieldDob.labelDescription}
            infoText={configs.fieldDob.labelDescription}
            required={configs?.OfieldDob?.mandatory === 'true'}
            validate={(value) => Validators.pastDateValidator(value,configs)}
          />
          <AddressInfo
            fieldsConfig={FormUtils.getAddressFieldConfigs('OtherPerson', configs)}
            formDataKey={otherPersonInfoKey}
          />
        </Fieldset>
      </div>
    </div>
  );
};

OtherPersonInfo.defaultProps = {
  id: '',
  className: 'otherPersonInfo',
  additionalClassNames: '',
};

export default OtherPersonInfo;
